module.exports = __webpack_public_path__ + "img/修大成.a81c360d.png";